import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { Box, Flex } from '@adsk/alloy-react-box';
import { DocumentTextIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import FormStatus from './FormStatus';
import { getFormDateString } from './helpers/utils';
import { useDisplayName, useFormTemplatesByUidMap } from './hooks';
import { ACTIVITY_VARIANTS } from '../constants';

const FormsActivityCard = React.forwardRef(({ entity: form, ...rest }, ref) => {
  const { locale } = useLocale(({ locale }) =>
    require(`./i18n/${locale}.json`),
  );
  const [isImgSrcFound, setIsImgSrcFound] = useState(true);
  const { data: formTemplatesMap, loading: isLoadingFormTemplatesMap } =
    useFormTemplatesByUidMap();

  const previewUrl = useMemo(
    () =>
      (!isLoadingFormTemplatesMap &&
        formTemplatesMap[form.type]?.urls.thumbnail) ||
      '',
    [form, formTemplatesMap, isLoadingFormTemplatesMap],
  );
  const displayName = useDisplayName(form);

  return (
    <ActivityCard ref={ref} {...rest}>
      <Flex>
        {isImgSrcFound ? (
          <img
            src={previewUrl}
            style={{
              height: '48px',
              width: '48px',
              marginRight: '18px',
            }}
            onError={() => {
              setIsImgSrcFound(false);
            }}
          />
        ) : (
          <Box
            padding="11px 14px 11px 14px"
            border={`1px solid ${theme.colors.charcoal200}`}
            borderRadius="4px"
            marginRight="18px"
          >
            <DocumentTextIcon size={20} />
          </Box>
        )}
        <Box flexGrow="1" overflow="hidden" paddingRight="5px">
          <Flex typography="bodyMediumBold">
            <Box typography="ellipsis" maxWidth="inherit" marginRight="8px">
              {displayName}
            </Box>
          </Flex>
          <Flex alignItems="center" marginTop="4px">
            <Box flexShrink="0" width="100px">
              {getFormDateString(form.report_date, locale)}
            </Box>
            <FormStatus status={form.status} />
          </Flex>
        </Box>
      </Flex>
    </ActivityCard>
  );
});

FormsActivityCard.displayName = 'FormsActivityCard';

FormsActivityCard.propTypes = {
  variant: PropTypes.oneOf(Object.values(ACTIVITY_VARIANTS)),
  entity: PropTypes.object.isRequired,
};

export default FormsActivityCard;
